<template>
    <VueDatePicker 
        v-model="date"
        mode="date" 
        format="dd/MM/yyyy"
        placeholder="dd/MM/yyyy"
        :enable-time-picker="false"
        :class="{'ring rounded-xl ring-primary-300' : isMenuVisible}"
        @open="isMenuVisible = true"
        @closed="isMenuVisible = false"
        v-bind="$attrs"
    >
        <template #input-icon>
            <span class="material-symbols-rounded self-center pl-3 text-white">calendar_month</span>
        </template>
        <template #clear-icon="{ clear }">
            <div class="flex pr-2 items-center">
                <span class="material-symbols-rounded self-center bg-danger/20 text-danger rounded-full" @click="clear">close_small</span>
            </div>
        </template>
    </VueDatePicker>
</template>

<script setup>
import { ref, watch } from "vue";
import { DateTime } from "luxon";

const clear = () => {
    date.value = undefined
}
const set = (val) => {
    date.value = val
}

defineExpose({ clear, set })
const emit = defineEmits(['dateChange'])

const date = ref()
const isMenuVisible = ref(false)

watch(
    () => date.value,
    () => {
        if(date.value){
            let startFormattedDate = DateTime.fromJSDate(new Date(date.value[0])).toFormat('yyyy-MM-dd')
            let endFormattedDate
            if(date.value[1]){
                endFormattedDate = DateTime.fromJSDate(new Date(date.value[1])).toFormat('yyyy-MM-dd')
            } else {
                endFormattedDate = startFormattedDate
            }
            emit('dateChange', [startFormattedDate, endFormattedDate])
        }
        else emit('dateChange', [])
    }
)

</script>

<style>
.dp__input{
    background-color: #121212 !important;
    border-radius: 0.75rem;
    border-color: #292929;
    display: flex;
    align-items: center;
    height: 42px;
    color: white
}
.dp__input:hover{
    border: 1px #292929 solid !important;
}
.dp__input_icon{
    display: flex;
    align-items: center;
}
.dp__menu{
    background-color: #121212 !important;
    border: 1px #292929 solid !important;
    border-radius: 0.75rem;
    color: white !important;
    button{
        color: white
    }
    div{
        color: white
    }

}
.dp__overlay_cell_active{
    background-color: #03ffaf;
    color: black !important
}
.dp__range_start{
    background: #03ffaf !important;
    color: black !important
}
.dp__range_end{
    background: #03ffaf !important;
    color: black !important
}
.dp__range_between{
    background: #03ffaf81 !important;
    color: black !important;
    border: 0px solid #03ffaf81
}
.dp__cell_offset{
    color: gray !important
}
.dp__input_icon_pad{
    padding-left: 45px;
}
.dp__cell_inner{
    color: white
}
.dp__active_date {
    background-color: #03ffaf;
    color: black !important
}

.dp__today {
    border: 1px solid #03ffaf;
}

.dp__arrow_top {
    display: none;
}

.dp__action_select {
    background: #03ffaf !important;
    color: black !important
}

.dp__overlay {
    background-color: #121212;
}
</style>